<style lang="stylus">
    .crypt-modal
        .input-row-wrap{
          margin-bottom: 16px
          display: flex;
          align-items: center;
          width: 100%
          span{
            font-size: 12px
            width: 102px
          }
          .ivu-input{
            height: 24px
            border: 1px solid var(--border-color-box-6);
            border-radius: 6px;
          }
        }
        .dialog-slot{
          width 480px
          padding 24px
          padding-top: 16px
          font-size 14px
        }
        .decrypt-tip
            margin-bottom 16px
            color var(--text-color-primary)
        .encrypt-tip,.lift-tip{
          color var(--text-color-primary)
          font-size: 12px
          margin-bottom: 24px
        }
        .input-zone
            .ivu-input-group-prepend
                background #e6e6e6
                >span
                    color #333
</style>

<template>
    <Dialog
        class="crypt-modal"
        :title="title"
        :showFooter="true"
        :zIndex="10000"
        :onlyOK="type === 'decry'"
        :showVipIcon="!vip && type !== 'decry'"
        @close="closeModal"
        @ok="beforeOk"
    >
        <div class="decrypt-tip" v-show="type == 'decry'">
            {{ $t("encrynote") }}
        </div>
        <div class="input-zone">
            <div class="input-row-wrap" v-show="type != 'lift'">
                <span>{{ $t("inputPassword") }}</span>
                <Input
                    v-model="password"
                    type="password"
                    class="top-input"
                    ref="passwordInput"
                    :maxlength="30"
                    @on-enter="beforeOk"
                    :placeholder="$t('inputPlacehoder')"
                    @paste="stopPaste"
                ></Input>
            </div>
            <div class="input-row-wrap" v-show="type != 'decry' && type != 'lift'">
                <span>{{ $t("confirmPassword") }}</span>
                <Input
                    v-model="confirmPassword"
                    type="password"
                    class="bottom-input"
                    :maxlength="30"
                    @on-enter="beforeOk"
                    :placeholder="$t('confirmPlacehoder')"
                    @paste="stopPaste"
                ></Input>
            </div>
        </div>
        <div class="encrypt-tip" v-show="type != 'decry' && type != 'lift'">
            <span style="color: red">*</span>
            {{ $t("note") }}
        </div>
        <div class="lift-tip" v-show="type == 'lift'">
            <span style="color: red">*</span>
            {{ $t("liftWarn") }}
        </div>
    </Dialog>
</template>

<script lang="ts">
    import Dialog from "./Dialog.vue";
    import { Component, Prop, Vue } from "vue-property-decorator";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class Prepare extends Vue {
        // 初始数据可以直接声明为实例的属性

        password = "";
        confirmPassword = "";

        stopPaste() {
            return false;
        }
        get type() {
            return this.$store.state.ui.cryptType;
        }
        get title() {
            return this.$t("operation." + this.type);
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        get fileID() {
            return this.$store.state.ui.fileID;
        }
        closeModal() {
            this.$store.commit("setStatus", {
                type: "showCryptModal",
                data: false,
            });
        }
        beforeOk() {
            var pattern1 = /\s/;
            var pattern2 = /[^\x21-\x7e]/g;
            if (this.type == "lift") {
                this.ok();
                return;
            }
            if (pattern1.test(this.confirmPassword)) {
                this.$edMessage.warning(this.$t("pdNoNull"));
            } else if (pattern2.test(this.confirmPassword)) {
                this.$edMessage.warning(this.$t("pdNoCnword"));
            } else if (this.password != this.confirmPassword && this.type != "decry") {
                this.$edMessage.warning(this.$t("pdNoEqual"));
            } else if (this.type != "decry" && (this.password.length < 4 || this.password.length > 30)) {
                this.$edMessage.warning(this.$t("pdLimit"));
            } else {
                this.ok();
            }
        }
        setDocPwd(pass) {
            this.$store.commit("setStatus", {
                type: "isEncrypt",
                data: !!pass,
            });
            window["_view"].setDocPassword(pass);
        }
        ok() {
            if (this.type !== "decry" && !this.$checkAuth({ type: "encrypt", buyTrigger: "encryptFile" }, "buyframe")) {
                return;
            }
            if (this.type == "decry") {
                //解密打开文件
                this.$bus.$emit("confirmFileDecryption", this.password);
                this.password = "";
                this.confirmPassword = "";
            } else if (this.type == "encry") {
                this.setDocPwd(this.confirmPassword);
                this.$root["ui"].toSaving(false, true, false, "setPwd");
                this.$edMessage.success(this.$t("encrySuccess"));
                this.$edApi.setFileEncryptStatus({
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    data: {
                        obj_id: this.fileID,
                        file_key: this.$store.getters.fileKey,
                        encrypt: 1,
                    },
                });
                this.closeModal();
            } else if (this.type == "change") {
                this.setDocPwd(this.confirmPassword);
                this.$root["ui"].toSaving(false, true, false, "changePwd");
                this.$edMessage.success(this.$t("changeSuccess"));
                this.closeModal();
            } else {
                this.setDocPwd("");
                this.$root["ui"].toSaving(false, true, false, "cancelPwd");
                this.$edMessage.success(this.$t("liftSuccess"));
                this.$edApi.setFileEncryptStatus({
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    data: {
                        obj_id: this.fileID,
                        file_key: this.$store.getters.fileKey,
                        encrypt: 0,
                    },
                });
                this.closeModal();
            }
        }
        //生命周期
        mounted() {
            this.$nextTick(() => {
                (<any>this.$refs.passwordInput).$refs.input.focus();
            });
        }
    }
</script>

<i18n>
{
  "zh": {
    "operation": {
      "change": "修改密码",
      "encry": "文档加密",
      "decry": "文档解密",
      "lift": "解除加密"
    },
    "inputPassword": "输入密码",
    "inputPlacehoder": "请输入密码",
    "confirmPassword": "确认密码",
    "pdNoEqual": "两次输入的密码不一致！",
    "confirmPlacehoder": "请再次确认密码",
    "encrySuccess": "加密成功！",
    "changeSuccess": "修改成功！",
    "liftSuccess": "解除成功！",
    "pdNoMatch": "输入密码与原密码不匹配！",
    "pdNoNull": "输入密码不能包含空格！",
    "pdNoCnword": "输入密码只允许英文字符，数字和特殊字符(!, #, $...)",
    "liftWarn": "确定要解除此文档的加密吗？",
    "pdLimit": "输入密码位数必须为4到30位之间！",
    "note": "注意：密码区分大小写。请妥善保管密码，一旦丢失或遗忘，文档则无法恢复。",
    "encrynote": "此文档已加密，请输入密码"
  },
  "en": {
    "operation": {
      "change": "Change Password",
      "encry": "Encrypt File",
      "decry": "Open Encrypted File",
      "lift": "Remove Encryption"
    },
    "inputPassword": "Password",
    "inputPlacehoder": "Please enter password",
    "confirmPassword": "Confirm Password",
    "pdNoEqual": "Two passwords do not match.",
    "confirmPlacehoder": "Please confirm the password.",
    "encrySuccess": "Encrypted successfully",
    "changeSuccess": "Password Changed",
    "liftSuccess": "Encryption Removed",
    "pdNoMatch": "Incorrect Password!",
    "pdNoNull": "The password cannot contain space characters!",
    "pdNoCnword": "Use only English letters, numbers and special characters (!, #, $, ...) for password.",
    "liftWarn": "Are you sure you want to remove the encryption of this file?",
    "pdLimit": "The password must contain 4-30 characters.",
    "note": "Note: The password is case sensitive. Please keep the password properly. Once lost or forgotten, the file cannot be recovered.",
    "encrynote": "This file is encrypted, please enter the password to open it."
  },
  "es": {
    "operation": {
      "change": "Cambia la contraseña",
      "encry": "Archivos cifrado",
      "decry": "Descifra archivos",
      "lift": "Desencriptar"
    },
    "inputPassword": "introducir la contraseña",
    "inputPlacehoder": "Por favor introduzca la contraseña",
    "confirmPassword": "Confirmar contraseña",
    "pdNoEqual": "Las dos contraseñas no coinciden",
    "confirmPlacehoder": "Por favor confirme la contraseña nuevamente",
    "encrySuccess": "¡Cifrado con éxito!",
    "changeSuccess": "¡Modificado con éxito!",
    "liftSuccess": "¡Quitado con éxito!",
    "pdNoMatch": "¡La contraseña entrada no coincide con la contraseña original!",
    "pdNoNull": "¡La contraseña entrada no puede contener espacios!",
    "pdNoCnword": "Utilice solo letras, números y caracteres especiales en inglés (!, #, $, ...) para la contraseña.",
    "liftWarn": "¿Está seguro de que desea descifrar este documento?",
    "pdLimit": "¡El número de contraseñas debe tener entre 4 y 30 dígitos!",
    "note": "Nota: la contraseña distingue entre mayúsculas y minúsculas. Mantenga la contraseña correctamente. Una vez perdido u olvidado, el archivo no se puede recuperar.",
    "encrynote": "Este archivo está encriptado, ingrese la contraseña abierta"
  },
  "fr": {
    "operation": {
      "change": "changer le mot de passe",
      "encry": "Cryptage des fichiers",
      "decry": "Décryptage de fichiers",
      "lift": "Déchiffrer"
    },
    "inputPassword": "Entrer le mot de passe",
    "inputPlacehoder": "Veuillez saisir le mot de passe",
    "confirmPassword": "Confirmez le mot de passe",
    "pdNoEqual": "Les mots de passe entrés deux fois sont incohérents!",
    "confirmPlacehoder": "Veuillez confirmer à nouveau le mot de passe",
    "encrySuccess": "Crypté avec succès!",
    "changeSuccess": "Modifié avec succès!",
    "liftSuccess": "Levé avec succès!",
    "pdNoMatch": "Le mot de passe saisi ne correspond pas au mot de passe d'origine!",
    "pdNoNull": "Le mot de passe saisi ne peut pas contenir d'espaces!",
    "pdNoCnword": "Utilisez uniquement des lettres, des chiffres et des caractères spéciaux en anglais (!, #, $, ...) pour le mot de passe.",
    "liftWarn": "Etes-vous sûr de vouloir déchiffrer ce document?",
    "pdLimit": "Le nombre de mots de passe doit être compris entre 4 et 30 chiffres!",
    "note": "Remarque: le mot de passe est sensible à la casse. Veuillez conserver le mot de passe correctement. Une fois perdu ou oublié, le fichier ne peut pas être récupéré.",
    "encrynote": "Ce fichier est crypté, veuillez saisir le mot de passe ouvert"
  },
  "jp": {
    "operation": {
      "change": "パスワードの変更",
      "encry": "ファイルの暗号化",
      "decry": "暗号化の解除",
      "lift": "ファイルの暗号化を解除"
    },
    "inputPassword": "パスワード",
    "inputPlacehoder": "パスワードを入力してください",
    "confirmPassword": "パスワードを再入力",
    "pdNoEqual": "2回のパスワードが一致していません！",
    "confirmPlacehoder": "パスワードを再入力してください（確認用）",
    "encrySuccess": "ファイルを暗号化されました！",
    "changeSuccess": "変更しました！",
    "liftSuccess": "暗号化を解除しました！",
    "pdNoMatch": "パスワードが間違っています！",
    "pdNoNull": "パスワードにスペースを含めることはできません！",
    "pdNoCnword": "パスワードには、英字、数字、および特殊文字（!、#、$、...）のみを使用してください",
    "liftWarn": "このドキュメントの暗号化を解除してもよろしいですか？",
    "pdLimit": "パスワードには少なくとも4文字を含める必要があります！",
    "note": "注意：パスワードは、大文字と小文字が区別されることに注意してください。忘れてしまったパスワードを回復することはできません。パスワードと、それに対応するドキュメント名を一覧にして、安全な場所に保管することをお勧めします。",
    "encrynote": "このファイルは暗号化されています。パスワードを入力してください"
  },
  "de": {
    "operation": {
      "change": "Passwort ändern",
      "encry": "Datei verschlüsseln",
      "decry": "Datei entschlüsseln",
      "lift": "Passwort entschlüsseln"
    },
    "inputPassword": "Passwort eingeben",
    "inputPlacehoder": "Bitte geben Sie Passwort ein",
    "confirmPassword": "Passwort sichern",
    "pdNoEqual": "Zwei Passwörter Stimmen nicht überein!",
    "confirmPlacehoder": "Bitte bestätigen Sie das Passwort",
    "encrySuccess": "Erfolgreich verschlüsselt!",
    "changeSuccess": "Passwort geändert!",
    "liftSuccess": "Verschlüsselung entfernt!",
    "pdNoMatch": "Falsches Passwort！",
    "pdNoNull": "Das Passwort kann keine Leerzeichen enthalten!",
    "pdNoCnword": "Verwenden Sie für das Passwort nur englische Buchstaben, Zahlen und Sonderzeichen (!, #, $, ...).",
    "liftWarn": "Sind Sie sicher, dass Sie die Verschlüsselung dieser Datei entfernen möchten?",
    "pdLimit": "Das Passwort muss 4-30 Zeichen enthalten!",
    "note": "Hinweis: das Passwort ist Groß-und Kleinschreibung. Bitte halten Sie das Passwort richtig. Einmal verloren oder vergessen, kann die Datei nicht wiederhergestellt werden.",
    "encrynote": "Diese Datei ist verschlüsselt, bitte geben Sie das Passwort ein, um Sie zu öffnen."
  },
  "pt": {
    "operation": {
      "change": "Mudar Senha",
      "encry": "Criptografar Arquivo",
      "decry": "Abrir Arquivo Criptografado",
      "lift": "Remover Criptografia"
    },
    "inputPassword": "Senha",
    "inputPlacehoder": "Por favor, insira a senha",
    "confirmPassword": "Confirmar Senha",
    "pdNoEqual": "Duas senhas não correspondem.",
    "confirmPlacehoder": "Por favor, confirme a senha.",
    "encrySuccess": "Criptografado com sucesso",
    "changeSuccess": "Senha alterada",
    "liftSuccess": "Criptografia Removida",
    "pdNoMatch": "Senha Incorreta!",
    "pdNoNull": "A senha não pode conter caracteres de espaço!",
    "pdNoCnword": "Use apenas letras, números e caracteres especiais em inglês (!, #, $, ...) para a senha.",
    "liftWarn": "Tem certeza de que deseja remover a criptografia deste arquivo?",
    "pdLimit": "A senha deve conter de 4 a 30 caracteres.",
    "note": "Nota: a senha diferencia maiúsculas de minúsculas. Por favor, guarde a senha corretamente. Uma vez perdido ou esquecido, o arquivo não pode ser recuperado.",
    "encrynote": "Este arquivo está criptografado, digite a senha para abri-lo."
  },
  "it": {
    "operation": {
      "change": "Cambia la password",
      "encry": "Crittografa file",
      "decry": "Decifra file",
      "lift": "Rimuovi crittografia"
    },
    "inputPassword": "inserire la password",
    "inputPlacehoder": "si prega di inserire la password",
    "confirmPassword": "Conferma la password",
    "pdNoEqual": "Le password inserite due volte non sono coerenti!",
    "confirmPlacehoder": "Conferma di nuovo la password",
    "encrySuccess": "Crittografia con successo!",
    "changeSuccess": "Modificato con successo!",
    "liftSuccess": "Rimosso con successo!",
    "pdNoMatch": "La password inserita non corrisponde alla password originale!",
    "pdNoNull": "La password inserita non può contenere spazi!",
    "pdNoCnword": "Utilizza solo lettere, numeri e caratteri speciali inglesi (!, #, $, ...) per la password.",
    "liftWarn": "Sei sicuro di voler decrittografare questo documento?",
    "pdLimit": "Il numero di password deve essere compreso tra 4 e 30 caratere!",
    "note": "Nota: la password fa distinzione tra maiuscole e minuscole. Si prega di conservare correttamente la password. Una volta perso o dimenticato, il file non può essere recuperato.",
    "encrynote": "Questo file è crittografato, inserisci la password per aprirlo."
  },
  "tw": {
    "operation": {
      "change": "修改密碼",
      "encry": "檔案加密",
      "decry": "檔案解密",
      "lift": "解除加密"
    },
    "inputPassword": "輸入密碼",
    "inputPlacehoder": "請輸入密碼",
    "confirmPassword": "確認密碼",
    "pdNoEqual": "兩次輸入的密碼不一致！",
    "confirmPlacehoder": "請再次確認密碼",
    "encrySuccess": "加密成功！",
    "changeSuccess": "修改成功！",
    "liftSuccess": "解除成功！",
    "pdNoMatch": "輸入密碼與原密碼不匹配！",
    "pdNoNull": "輸入密碼不能包含空格！",
    "pdNoCnword": "輸入密碼只允許英文字符，數字和特殊字符(!, #, $...)",
    "liftWarn": "確定要解除此檔案的加密嗎？",
    "pdLimit": "輸入密碼位數必須為4到30位之間！",
    "note": "注意：密碼區分大小寫。請妥善保管密碼，一旦丟失或遺忘，檔案則無法恢復。",
    "encrynote": "此檔案已加密，請輸入密碼"
  },
  "kr": {
    "operation": {
      "change": "암호 변경",
      "encry": "파일 암호화",
      "decry": "암호화된 파일 열기",
      "lift": "암호화 제거"
    },
    "inputPassword": "비밀번호 입력",
    "inputPlacehoder": "비밀번호를 입력해 주세요.",
    "confirmPassword": "비밀번호 확인 ",
    "pdNoEqual": "두 번 입력한 비밀번호가 일치하지 않습니다!",
    "confirmPlacehoder": "암호를 확인하십시오.",
    "encrySuccess": "성공적으로 암호화됨",
    "changeSuccess": "비밀번호 변경",
    "liftSuccess": "암호화 제거됨",
    "pdNoMatch": "암호가 잘못되었습니다!",
    "pdNoNull": "암호에는 공백 문자를 사용할 수 없습니다!",
    "pdNoCnword": "암호에 영어 문자, 숫자 및 특수 문자(!, #, $, ...)만 사용합니다.",
    "liftWarn": "이 파일의 암호화를 제거하시겠습니까?",
    "pdLimit": "비밀번호 자릿수를 입력하려면 4- 30자리가 되어야 합니다!",
    "note": "참고: 암호는 대소문자를 구분합니다. 암호를 올바르게 보관하십시오. 분실 또는 잊어버린 파일은 복구할 수 없습니다.",
    "encrynote": "파일이 암호화되어 있습니다. 파일을 열려면 암호를 입력하십시오."
  }
}
</i18n>
